'use client';

import React from 'react';
import PlayerDetailsContent from '@/app/dashboard/players/components/player-details-content';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { setPlayerDetails } from '@/store/reducers/drawer-content-slice';
import { getUi, hideDrawerState } from '@/store/reducers/ui-slice';

import { GeneralDrawer } from '@/types/general';

import DrawerTemplate from '../core/drawer-template';

export default function PlayerDetailsDrawer(): React.JSX.Element | null {
  const { drawerState } = useAppSelector(getUi);

  const dispatch = useAppDispatch();

  return (
    <DrawerTemplate
      open={drawerState.PLAYER_DETAILS}
      onClose={() => {
        dispatch(hideDrawerState(GeneralDrawer.PLAYER_DETAILS));
        dispatch(setPlayerDetails(null));
      }}
      title="Player Details"
      width="830px"
    >
      <PlayerDetailsContent />
    </DrawerTemplate>
  );
}
